// components/Impressions.jsx
import React from "react";
import {
  Grid,
  Card,
  CardMedia,
  Checkbox,
  IconButton,
  Box,
  Typography,
} from "@mui/material";
import ArrowCircleDownIcon from "@mui/icons-material/ArrowCircleDown";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import EditIcon from "@mui/icons-material/Edit";

export default function Impressions({
  allImages,
  selectedImages,
  handleSelectImage,
  downloadImage,
  openImageCropper,
  editCountImage,
  displayEdit = true, // prop للتحكم في عرض زر التعديل
}) {
  return (
    <Grid container spacing={2}>
      {allImages?.map((image, index) => (
        <Grid item xs={3} key={image.id}>
          <Card>
            <Typography sx={{ marginLeft: "2%" }}>N : {index + 1}</Typography>
            <Box display="flex" justifyContent="space-between">
              <Checkbox
                checked={selectedImages.includes(image.id)}
                onChange={() => handleSelectImage(image.id)}
              />
              <Box display="flex" alignItems="center">
                <IconButton onClick={() => editCountImage(index, -1)}>
                  <RemoveIcon />
                </IconButton>
                <Typography variant="body1" mx={1}>
                  {image.Number}
                </Typography>
                <IconButton onClick={() => editCountImage(index, +1)}>
                  <AddIcon />
                </IconButton>
              </Box>
            </Box>

            {/* شرط عرض الصورة حسب نوع المنتج */}
            {image.Produit.NomProduit === "polaroid" ? (
              <CardMedia
                component="img"
                image={image.ImageTraites[0].url}
                alt="Image Traitee"
                sx={{
                  height: 300,
                  width: "100%",
                  objectFit: "cover",
                  objectPosition: "left center",
                }}
                onClick={() => handleSelectImage(image.id)}
              />
            ) : image.Produit.NomProduit === "instax" ? (
              <Box
                sx={{
                  height: 320,
                  width: "100%",
                  overflow: "hidden",
                  position: "relative",
                  backgroundColor: "#f3e5f5",
                }}
              >
                <CardMedia
                  component="img"
                  image={image.ImageTraites[0].url}
                  alt="Image Traitee"
                  sx={{
                    height: "100%",
                    width: "auto",
                    margin: "0 auto",
                    display: "block",
                  }}
                  onClick={() => handleSelectImage(image.id)}
                />
              </Box>
            ) : (
              <CardMedia
                component="img"
                image={image.ImageTraites[0].url}
                alt="Image Traitee"
                sx={{
                  height: 200,
                  width: "100%",
                  objectFit: "contain",
                  backgroundColor: "#fafafa",
                }}
                onClick={() => handleSelectImage(image.id)}
              />
            )}

            {/* زر التعديل يظهر فقط إذا كان displayEdit = true */}
            <Box display="flex" justifyContent="space-between" p={1}>
              {displayEdit && (
                <IconButton onClick={() => openImageCropper(image)}>
                  <EditIcon />
                </IconButton>
              )}
              <IconButton
                onClick={() =>
                  downloadImage(image.ImageTraites[0].url, image.id)
                }
              >
                <ArrowCircleDownIcon />
              </IconButton>
            </Box>
          </Card>
        </Grid>
      ))}
    </Grid>
  );
}
